export default __webpack_public_path__ + "static/footer-logo-707a304c53fe5814f790e9a8ccabdeb8.svg";